import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { commentKeys } from './queryKeys';
import { deleteBroadcastComment } from 'api/comment.service';

export const useBroadcastCommentDeleteQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (info: { broadcastId: string; commentId: string }) => {
      setLoading();

      return deleteBroadcastComment(info.commentId);
    },
    onSuccess: () => {
      toast.success('Comment has been deleted successfully');
    },
    onError: (error: AxiosError) => toast.error(error.message),
    onSettled: (_comment, _error, info) => {
      removeLoading();
      queryClient.invalidateQueries({
        queryKey: commentKeys.broadcast(info.broadcastId),
      });
    },
  });

  return { isLoading: isPending, mutate };
};
